var map = {
	"./full_1.jpg": 56,
	"./full_2.jpg": 57,
	"./full_3.jpg": 58,
	"./full_4.jpg": 59,
	"./full_5.jpg": 60,
	"./full_6.jpg": 61,
	"./full_7.jpg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;